import { reactive } from 'vue'
import ChunjieXu from '../../public/img/board/ChunjieXu.png'
import HuaiyanLiu from '../../public/img/board/HuaiyanLiu.png'
import HongyunWu from '../../public/img/board/HongyunWu.png'
import HeungMingWong from '../../public/img/board/HeungMingWong.png'
import MingHe from '../../public/img/board/MingHe.png'
import WeiZhu from '../../public/img/board/WeiZhu.png'

export const WebcastEvents = reactive([
  {
    title: 'Fendan Technology Closes Series B Strategic Financing to Further Its Growth in Marriage and Childbearing Sectors',
    date: '2019-08-13',
    content: '',
  },
  {
    title: 'Fendan Technology Awarded the “Golden Rose” Most Potential Enterprise of Wedding Industry',
    date: '2018-12-09',
    content: '',
  },
  // {
  //   title: '分蛋科技与网商金融达成战略合作，共建科技金融新生态',
  //   date: '2018-8-6',
  //   content: '',
  // },
  {
    title: 'Fendan Technology Closes Series A Financing',
    date: '2017-08-07',
    content: '',
  },
])

export const BoardofDirectorsExecutiveOfficers = reactive([
  {
    avatar: ChunjieXu,
    name: 'Chunjie Xu',
    desc: 'Chief Executive Officer and Chairman of the Board of Directors',
    content:
      'Mr. Chunjie Xu has served as Chairman of the board of directors of the Company since October 10, 2019, the Chief Executive Officer of the Company since July 1, 2021, and the Chief Executive Officer of Shanghai Fendan since July 1, 2016. He also concurrently serves as legal representatives for our VIE and its subsidiaries. He has over 15 years of experience in financing and operations management. He started his career working as a senior specialist of the planning department at Guangdong Buynow Commercial Facilities Leasing Management Co., Ltd., a commercial real estate leasing and management company, from July 2002 to June 2005. From July 2005 to June 2016, he served as a senior manager of the credit card operations department at the credit card center of Industrial Bank. Mr. Xu received a bachelor’s degree in Industrial Foreign Trade from Donghua University and a master’s degree in Public Management from East China University of Political Science and Law in China in June 2002 and June 2013, respectively. ',
  },
  {
    avatar: HuaiyanLiu,
    name: 'Huaiyan Liu',
    desc: 'Chief Financial Officer',
    content:
      'Ms. Huaiyan Liu has served as the Chief Financial Officer of FD Technology Inc. since July 1, 2021 and the financial director of Shanghai Fendan since July 1, 2016. Ms. Liu has over 20 years’ experience in accounting and financing. She started her career as an accounting supervisor and office staff from December 1999 to May 2010 at China Certification & Inspection Group Shenzhen Co., Ltd., an independent third party inspection company in China, where she was mainly responsible for bookkeeping and tax returns, preparing financial reports, participating in the company’s tax planning and budgets, developing and implementing financial management policy, and office administration matters. From June 2010 to September 2010, she served as an accounting and financial supervisor at Shenzhen Growth Element Exhibitions Planning Co., Ltd, an exhibition planning company, supervising and coordinating the accounting and auditing related matters of the company. From May 2011 to May 2013, she worked as a financial supervisor at Shenzhen Shenwei Feeding Transportation Co., Ltd, a customs declaration agency company, in charge of all financial and accounting matters of the company. From December 2013 to September 2014, she worked as a financial supervisor at Shenzhen Ziyun Xiangshe Cultural Investment Partnerships, a limited partnership primarily engaged in investment and management consulting, and domestic trade. From October 2014 to June 2016, she joined Shenzhen Lingnan Jiahui Financial Information Consulting Co., Ltd, a financial consulting company, as a financial manager, where she was mainly responsible for developing and updating financial management policies of the company, and organizing, implementing and coordinating the accounting and auditing matters of the company. Ms. Liu received an associate’s degree in English from Shenzhen University and a bachelor’s degree in Financing from The Open University of China in June 2003 and July 2007, respectively.',
  },
  {
    avatar: HongyunWu,
    name: 'Hongyun Wu',
    desc: 'Director',
    content:
      'Ms. Hongyun Wu has served as our director since August 6, 2021, and human resources director of Shanghai Fendan Shenzhen Branch since July 1, 2016. She has over 15 years of experience in human resource and office management. From July 2002 to May 2014, she served as an office manager at Shenzhen Sanjiu Real Estate (Group) Co., Ltd, a company primarily engaged in real estate development, in charge of office administration and human 115 resource matters. From June 2014 to June 2016, she served as HR director of Shenzhen Lingnan Jiayi Financial Information Consulting Co., Ltd, a financial consulting company, in charge of office administration and human resource matters. Ms. Wu received a bachelor’s degree in Human Resources Management from South China Normal University in July 2004.',
  },
  {
    avatar: HeungMingWong,
    name: 'Heung Ming Wong',
    desc: 'Director Nominee',
    content:
      'Mr. Heung Ming Wong will serve as our independent director upon effectiveness of our registration statement on Form F-1, of which this prospectus is a part. Mr. Wong has over twenty years’ experience in advising multinational companies of finance, accounting, internal control and corporate governance matters. Mr. Wong has served as a director of TD Holdings, Inc. (Nasdaq: GLG), a company engaged in commodity trading and supply chain services businesses, since April 2021. From June 2020 to March 2021, Mr. Wong served as Chief Financial Officer of Meten EdtechX Education Group Ltd. (Nasdaq: METX), a leading English language training service provider in China. He has served since April 2021 as an independent director of TD Holdings, Inc. (Nasdaq: GLG), a company engaging in commodity trading business and supply chain service business in China, since November 2010 as an independent director of Shifang Holding Group Ltd. (1831HK), a Hong Kong-listed company which provides a wide range of integrated print media and digital media services to advertisers and since March 2020 as an independent director of Raffle Interior Ltd. a company engaged in the interior decoration business. Previously, he also served as the Chief Financial Officer from March 2017 to November 2018 at Frontier Services Group (0500HK), a company listed on the Hong Kong Stock Exchange, which is a leading provider of integrated security, logistics, insurance and infrastructure services for clients operating in developing regions. Prior to that, Mr. Wong worked for Deloitte Touche Tohmatsu (China) and PricewaterhouseCoopers (China) for an aggregate of more than 11 years. Mr. Wong graduated from the City University of Hong Kong in 1993 with a bachelor’s degree in Accountancy and obtained a master’s degree in Electronic Commerce from the Open University of Hong Kong in 2003. He is a fellow member of the association of Chartered Certified Accountants and the Hong Kong institute of Certified Public Accountants and a member of the Hong Kong Institute of Certified Internal Auditor.',
  },
  {
    avatar: MingHe,
    name: 'Ming He',
    desc: 'Director Nominee',
    content:
      'Mr. Ming He will serve as our independent director upon effectiveness of our registration statement on Form F-1, of which this prospectus is a part. Mr. He has served as Chief Financial Officer at Cenntro Automotive Group Limited, a Cayman Islands company engaged in the research and development, manufacturing and sales of commercial electric vehicles, since February 2014 till present. From March 2010 to April 2012, he served as the Chief Financial Officer of Shengkai Innovations, Inc., a company engaged in design, manufacture and sales of industrial ceramic valves in China and formerly listed on Nasdaq under the ticker “VALV” until July 2013, where Mr. He assisted the company in Nasdaq listing and a number of public offerings. Between January 2007 and February 2010, Mr. He served as Chief Financial Officer of Zhongchai Machinery, Inc., a company engaged in manufacturing and supply of machinery products and previously quoted on the OTC Bulletin Board under the symbol “EOPI”. From November 2004 until January 2007, Mr. He served as the Senior Manager for Investor Relations at SORL Auto Parts, Inc. a corporation engaged in the research and development, manufacturing and sales of spare parts of automobiles and rail vehicles and previously listed on Nasdaq under the ticker “SORL” until May 2020, where he guided the process of SORL’s listing in U.S. capital market and a public offering in November 2006. Mr. He holds designations of Chartered Financial Analyst and Certified Public Accountant in the United States. Mr. He received his Master of Science degree in Accountancy in 2004 and Master of Business Administration degree in 2003 from University of Illinois at Urbana-Champaign. He also received his bachelor’s degree from Shanghai University of International Business and Economics (f.k.a. Shanghai Institute of Foreign Trade) in 1992.',
  },
  {
    avatar: WeiZhu,
    name: 'Wei Zhu',
    desc: 'Director Nominee',
    content:
      'Mr. Wei Zhu will serve as our independent director upon effectiveness of our registration statement on Form F-1, of which this prospectus is a part. Mr. Zhu has over twenty years’ experience in finance and accounting. Since June 2021, Mr. Zhu has served as the Deputy General Manager at Shanghai Fimet Medical Instrument Co., Ltd., a company engaged in the research and development, manufacturing and sales of dental treatment machines. From June 2019 to June 2021, he served as the Chief Financial Officer of China Minsheng Investment Group, a global investment group in China. Between May 2015 and June 2019, Mr. Zhu served as the Chief Financial Officer and Secretary of the board of Shanghai Dongze Water Technology Co., Ltd., a company engaged in design and construction of city infrastructures on flood protection and manufacturing of flood protection professional.',
  },
])

export const CommitteeComposition = reactive({
  columns: [
    {
      title: 'Director',
      dataIndex: 'director',
      key: 'director',
    },
    {
      title: 'Audit Committee',
      dataIndex: 'auditCommittee',
      key: 'auditCommittee',
    },
    {
      title: 'Compensation Committee',
      dataIndex: 'compensationCommittee',
      key: 'compensationCommittee',
    },
    {
      title: 'Nominating Committee',
      dataIndex: 'nominatingCommittee',
      key: 'nominatingCommittee',
    },
  ],

  data: [
    {
      director: 'Chunjie Xu',
      auditCommittee: 'Member',
      compensationCommittee: 'Member',
      nominatingCommittee: 'Chairpersion',
    },
    {
      director: 'Hongyun Wu',
      auditCommittee: 'Member',
      compensationCommittee: 'Chairpersion',
      nominatingCommittee: 'Member',
    },
    {
      director: 'Hongyun Wu',
      auditCommittee: 'Chairpersion',
      compensationCommittee: 'Member',
      nominatingCommittee: 'Member',
    },
  ],
})

export const GovernanceDocuments = reactive([
  {
    title: 'Code of Ethics',
    date: '2019-8-13',
    src: 'https://fdshare.oss-cn-shenzhen.aliyuncs.com/meet/game/personality/bg1.jpg',
  },
  {
    title: 'Audit Committee Charter',
    date: '2019-8-13',
    src: '',
  },
  {
    title: 'Compensation Committee Charter',
    date: '2019-8-13',
    src: '',
  },
  {
    title: 'Nominating and Corporate Governance Charter',
    date: '2019-8-13',
    src: '',
  },
])

export const AnnualGeneralMeetingDownloadList = reactive([
  {
    title: 'Annual Report',
    link: '',
  },
  {
    title: 'Proxy Card',
    link: '',
  },
  {
    title: 'Proxy Statement',
    link: '',
  },
])

export const InterimReportsDownloadList = reactive([
  {
    year: 2021,
    list: [
      {
        title: 'FD TECHNOLOGY INC. First Half of FY2021 Earnings Results',
        link: '',
      },
      {
        title: 'FD TECHNOLOGY INC. First Half of FY2021 Earnings Conference Call Edited Transcript',
        link: '',
      },
      {
        title: 'FD TECHNOLOGY INC. First Half of FY2021 Earnings Webcast',
        link: '',
      },
    ],
  },
  {
    year: 2020,
    list: [
      {
        title: 'FD TECHNOLOGY INC. First Half of FY2020 Earnings Results',
        link: '',
      },
      {
        title: 'FD TECHNOLOGY INC. First Half of FY2020 Earnings Webcast',
        link: '',
      },
    ],
  },
  {
    year: 2019,
    list: [
      {
        title: 'FD TECHNOLOGY INC. First Half of FY2019 Earnings Results',
        link: '',
      },
    ],
  },
])

export const AnnualReportsDownloadList = reactive([
  {
    date: 'Sep 27, 2021',
    list: [
      {
        title: 'Annual Report Fiscal Year 2021',
        link: '',
      },
      {
        title: 'FD TECHNOLOGY INC. Fiscal Year 2021 Earnings Transcript',
        link: '',
      },
      {
        title: 'FD TECHNOLOGY INC. Fiscal Year 2021 Earnings Webcast',
        link: '',
      },
    ],
  },
  {
    date: 'Sep 28, 2020',
    list: [
      {
        title: 'Annual Report Fiscal Year 2020',
        link: '',
      },
      {
        title: 'FD TECHNOLOGY INC. Fiscal Year 2020 Earnings Transcript',
        link: '',
      },
      {
        title: 'FD TECHNOLOGY INC. Fiscal Year 2020 Earnings Webcast',
        link: '',
      },
    ],
  },
  {
    date: 'Oct 15, 2019',
    list: [
      {
        title: 'Annual Report Fiscal Year 2019',
        link: '',
      },
    ],
  },
])
